import React from 'react';

import { Icon, Link, Wrapper } from 'components/FooterSocialStyles';

import {
  FacebookBrandIcon,
  LinkedinBrandIcon,
  TwitterBrandIcon,
  YoutubeBrandIcon,
} from '@datacamp/waffles-icons';

const social = [
  {
    name: 'facebook',
    icon: <FacebookBrandIcon />,
    href: 'https://www.facebook.com/pages/DataCamp/726282547396228',
  },
  {
    name: 'twitter',
    icon: <TwitterBrandIcon />,
    href: 'https://twitter.com/datacamp',
  },
  {
    name: 'linkedin',
    icon: <LinkedinBrandIcon />,
    href: 'https://www.linkedin.com/company/datamind-org',
  },
  {
    name: 'youtube',
    icon: <YoutubeBrandIcon />,
    href: 'https://www.youtube.com/channel/UC79Gv3mYp6zKiSwYemEik9A',
  },
];

const FooterSocial = () => {
  return (
    <Wrapper>
      {social.map(({ name, icon, href }) => (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          className="dc-social-media__link dc-u-fxi-fs-0"
          href={href}
          key={`link_${name}`}
        >
          <Icon>{icon}</Icon>
        </Link>
      ))}
    </Wrapper>
  );
};

export default FooterSocial;
